import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Lightbulb, Check, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function ManagerOpportunities() {
  const { profile } = useAuth();
  const [opportunities, setOpportunities] = useState([]);
  useEffect(() => {
    // For demo: opportunities = matches against this manager (admin endpoint).  Use simpler approach: query company requests with shortlists where manager is included
    const load = async () => {
      try {
        const projects = await api.get("/projects/");
        // Render projects directly as 'opportunities' - completed ones still show context
        // Plus we can also show "interested in your profile" from the user
        setOpportunities(projects.data || []);
      } catch (e) {}
    };
    load();
  }, []);
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Opportunità</h1>
      <p className="text-sm text-slate-600 mb-6">Visualizza le richieste in cui sei stato selezionato per la shortlist. I dati aziendali rimangono anonimi fino al primo contatto.</p>
      <div className="space-y-3">
        {opportunities.length ? opportunities.map(o => (
          <div key={o.id} className="cxo-card p-5 flex items-start gap-4">
            <div className="w-11 h-11 rounded-lg bg-[#EAF0FF] flex items-center justify-center"><Lightbulb size={18} className="text-[#2D6BFF]" /></div>
            <div className="flex-1">
              <h3 className="font-semibold text-slate-900">{o.title}</h3>
              <p className="text-sm text-slate-600 mt-0.5">Pacchetto: {o.package} · Stato: {o.status}</p>
            </div>
            <Badge className="bg-[#E9F8F1] text-[#1F9D6A] border-0">Attivo</Badge>
          </div>
        )) : <div className="cxo-card p-10 text-center text-slate-500">Nessuna opportunità al momento. Completa il profilo per migliorare il match.</div>}
      </div>
    </div>
  );
}
